module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g text-center"
  }, [_c('div', {
    staticClass: "pure-u-1"
  }, [_c('Loading')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d582746!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Subscriber.vue
// module id = 366
// module chunks = 1